import { DateInputLocalized } from '@components'

import { ReactElement, useCallback } from 'react'

import { useContactBalanceListFilters } from '../../hooks/useContactBalanceListFilters'
import { getQueryDate } from '../../utils/getQueryDate'
import * as Styled from './styles'

export const ContactBalanceDateSelector = (): ReactElement => {
  const [{ date }, setFilters] = useContactBalanceListFilters()

  const handleChange = useCallback(
    (dateToChange?: Date | null) => {
      setFilters({
        page: 1,
        date: dateToChange ? getQueryDate(dateToChange) : undefined,
      })
    },
    [setFilters],
  )

  return (
    <Styled.ContactBalanceDateSelectorWrapper>
      <DateInputLocalized value={date ? new Date(date) : undefined} onChange={handleChange} />
    </Styled.ContactBalanceDateSelectorWrapper>
  )
}
